import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "./lib/context/user";
import { IdeasProvider } from "./lib/context/ideas";
import { BabyActivitiesProvider } from "./lib/context/activities";
import TimeAgo from "javascript-time-ago";
import { registerServiceWorker } from "./serviceWorkerRegistration";

import en from "javascript-time-ago/locale/en.json";
import { Toaster } from "react-hot-toast";

TimeAgo.addDefaultLocale(en);

// Register Service Worker for PWA
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <IdeasProvider>
          <BabyActivitiesProvider>
            <App />
            <Toaster position="top-center" />
          </BabyActivitiesProvider>
        </IdeasProvider>
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
